import { createGtagHelpers } from '@ui/lib/analytics'
import { ENV } from '../env'
import { umamiTrack } from './umami'

const gtagHelpers = createGtagHelpers({
  gaId: ENV.GA_ID,
  enabled: ENV.IS_PRODUCTION_MODE
})

export const { gaId, isGAEnabled, pageview } = gtagHelpers

/**
 * Sends the event to Google Analytics and mirrors it to Umami, so both
 * dashboards share the same event names and the funnel stays complete even when
 * GA is blocked.
 */
export const event = ({ action, ...params }: { action: string;[key: string]: string | number | boolean }) => {
  // Page views are already auto-tracked by the Umami script.
  if (action !== 'page_view') {
    umamiTrack(action, params)
  }
  gtagHelpers.event({ action, ...params })
}

export { analytics, setAnalyticsUser, trackEvent, trackPageView } from './client'
export { trackServerEvent } from './server'
export { isUmamiEnabled, umamiIdentify, umamiPageView, umamiTrack } from './umami'
export type { UmamiEventData, UmamiVisitor } from './umami'
